export default __webpack_public_path__ + "static/media/3.041a3bc9.jpg";